import './IconArrowRight.css';
import React from 'react';
import { styled } from 'linaria/lib/react';
const IconArrowLeft = _ref => {
  let {
    width = 20,
    height = 20,
    className,
    fill = '#0067B9'
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledSVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 20 20",
    className: className
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    width: "142.9%",
    height: "142.9%",
    x: "-21.4%",
    y: "-21.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: "2",
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: "2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "nonzero",
    d: "M12.288 4a2.137 2.137 0 0 0 .285 2.925l2.436 2.116H1v1.916h14.009l-2.436 2.117A2.137 2.137 0 0 0 12.288 16L19 10l-6.712-6z"
  }));
};
const StyledSVG = /*#__PURE__*/styled("svg")({
  name: "StyledSVG",
  class: "s107kaqp"
});
export default IconArrowLeft;